import { Modal, ModalPrimaryActionButton } from '@la/ds-ui-components';
import styles from './PaymentPolicyModal.module.scss';

export type PaymentPolicyModalProps = {
  closeModal: () => void;
  modalTitle: string;
  open: boolean;
  policyContent?: string;
  policyName?: string;
};

/* PaymentPolicyModal */
export default function PaymentPolicyModal({
  closeModal,
  modalTitle,
  open,
  policyContent,
  policyName,
}: PaymentPolicyModalProps) {
  const dangerousHTML = policyContent
    ? { __html: policyContent }
    : { __html: '' };

  return (
    <Modal
      onOpenChange={closeModal}
      open={open}
      primaryAction={
        <ModalPrimaryActionButton onClick={closeModal}>
          Done
        </ModalPrimaryActionButton>
      }
      size="medium"
      title={modalTitle}
    >
      <div className={styles.paymentPolicyName}>
        {policyName ?? 'Payment Policy'}
      </div>
      <div
        className={styles.paymentPolicyContent}
        dangerouslySetInnerHTML={dangerousHTML}
      />
    </Modal>
  );
}
/* */
